import React from 'react';
import { Group, Panel, SimpleCell } from '@vkontakte/vkui';
import { Icon28ChevronRightOutline, Icon28LockOutline, Icon28StarsOutline } from '@vkontakte/icons';
import { AppShell, ScreenHeader } from '../../components/Layout/AppShell';
import { EmptyState } from '../../components/States/States';
import { ACHIEVEMENTS_PANEL } from '../../routing/routing';

export function AchievementsPanel({ nav = ACHIEVEMENTS_PANEL, achievements, loading, onBack, selectAchievement }) {
  return (
    <Panel nav={nav}>
      <ScreenHeader title="Мои достижения" onBack={onBack} />
      <AppShell>
        <Group>
          {achievements.length > 0 ? (
            achievements.map((item) => (
              <SimpleCell
                key={item.id}
                before={item.is_opened ? <Icon28StarsOutline /> : <Icon28LockOutline />}
                after={<Icon28ChevronRightOutline />}
                subtitle={item.is_opened ? 'Открыто' : 'Пока закрыто'}
                onClick={() => selectAchievement(item)}
                expandable
              >
                {item.name || 'Достижение'}
              </SimpleCell>
            ))
          ) : !loading ? <EmptyState /> : null}
        </Group>
      </AppShell>
    </Panel>
  );
}
